import id from './{id}';
import query from './query';
import get from './get';
import post from './post';
import { NodeType } from './../../index';

export type PostPayload = {
  archiveNumber?: number;
  area?: string;
  building?: string;
  floor?: string;
  folderId: number;
  isActive?: boolean;
  location: NodeType['location'];
  metadata: NodeType['metadata'];
  mute?: boolean;
  nodeTypeId: number;
  parentNodeId?: number;
  tags?: NodeType['tags'];
  uniqueId: string;
  vanity: string;
};
export default { id, query, get, post };
